export const columns = [
  {
    headerName: 'Category',
    field: 'category',
    width: 100,
    cellRenderer: 'activityComponent',
    cellRendererParams: {
      displayType: 'icon',
    },
  },
  { headerName: 'Type', field: 'typeName', width: 150 },
  { headerName: 'Valid From', field: 'validFrom', width: 100 },
  { headerName: 'Valid To', field: 'validTo', width: 100 },
];
